import { render } from "./StickCard.vue?vue&type=template&id=4ec79d52&scoped=true&ts=true"
import script from "./StickCard.vue?vue&type=script&lang=ts"
export * from "./StickCard.vue?vue&type=script&lang=ts"

import "./StickCard.vue?vue&type=style&index=0&id=4ec79d52&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec79d52"]])

export default __exports__